import * as route from "../routes/constants";
import { createURL } from "../utils/menus";
import { sportTypes } from "../config/sport-types";

const root = "/yaklasan-maclar";

const markets = {
    yaklasan_maclar8: {
        label: "Yaklaşan Maçlar - 8 Maç",
        slug: "yaklasan-maclar-8",
        translateKey: "yaklasan_maclar8"
    },
    yaklasan_maclar11: {
        label: "Yaklaşan Maçlar - 11 Maç",
        slug: "yaklasan-maclar-11",
        translateKey: "yaklasan_maclar11"
    },
};

const FixtureMenuItems = [
    {
        label: sportTypes.futbol.label,
        path: route.FIXTURE_FOOTBALL,
        icon: "football",
        translateKey:"futbol",
        children: [
            {
                label: markets.yaklasan_maclar11.label,
                path: createURL(root, sportTypes.futbol.slug, markets.yaklasan_maclar11.slug),
                translateKey: markets.yaklasan_maclar11.translateKey
            },
            {
                label: markets.yaklasan_maclar8.label,
                path: createURL(root, sportTypes.futbol.slug, markets.yaklasan_maclar8.slug),
                translateKey: markets.yaklasan_maclar8.translateKey
            },
        ],
    },
    {
        label: sportTypes.basketbol.label,
        path: route.FIXTURE_BASKETBALL,
        icon: "basketball",
        translateKey:"basketbol",
        children: [
            {
                label: markets.yaklasan_maclar11.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.yaklasan_maclar11.slug),
                translateKey: markets.yaklasan_maclar11.translateKey
            },
            {
                label: markets.yaklasan_maclar8.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.yaklasan_maclar8.slug),
                translateKey: markets.yaklasan_maclar8.translateKey
            },
        ],
    },
    {
        label: sportTypes.tenis.label,
        path: route.FIXTURE_TENNIS,
        icon: "tennis",
        translateKey:"tenis",
    },
    {
        label: sportTypes.voleybol.label,
        path: route.FIXTURE_VOLLEYBALL,
        icon: "volleyball",
        translateKey:"voleybol",
    },
];

export default FixtureMenuItems;
